import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPoMaterials } from "./api";

const POPageContext = createContext();
export const usePOPageContext = () => useContext(POPageContext);

function POPageContextProvider({ children }) {
  const { plantId, poId } = useParams();
  const [selectedPo, setSelectedPo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPo = async (id) => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getPoMaterials(id);
      setSelectedPo(data);
    } catch (err) {
      console.error("Failed to fetch PO:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (poId) {
      fetchPo(poId);
    }
  }, [poId]);

  return (
    <POPageContext.Provider
      value={{
        plantId,
        poId,
        selectedPo,
        setSelectedPo,
        loading,
        error,
        fetchPo,
      }}
    >
      {children}
    </POPageContext.Provider>
  );
}

export { POPageContextProvider, POPageContext };
